import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Replace with your actual Firebase config values from the Firebase console
const firebaseConfig = {
    apiKey: "AIzaSyAJMgzWwD7VVkSM9c2UfJPctYFdl3drtVo",
    authDomain: "taximailer-2426b.firebaseapp.com",
    databaseURL: "https://taximailer-2426b-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "taximailer-2426b",
    storageBucket: "taximailer-2426b.firebasestorage.app",
    messagingSenderId: "523741223982",
    appId: "1:523741223982:web:eb20e05b4bf185f8dc93bf"
  };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
